import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { get } from "../../../components/Utils/CallApi";
import { setError } from "../appSlice";

export const fetchLanguages = createAsyncThunk(
  "languages/list",
  async ({ companyId }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = "companyId=" + companyId;
      const response = await get("languages/list", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result || "Unknown error occurred");
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

const languagesSlice = createSlice({
  name: "languages",
  initialState: {
    languagesList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLanguages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLanguages.fulfilled, (state, action) => {
        state.loading = false;
        state.languagesList = action.payload;
      })
      .addCase(fetchLanguages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default languagesSlice.reducer;
